export const configAlerta = (resp) => ({
  message: resp.msg,
  position: { x: "right", y: "top" },
  color: resp.type,
  error: !!resp.error ? resp.error : "",
  endpoint: !!resp.endpoint ? resp.endpoint : "",
});

export const construirAlertaRespuesta = (resp, err = false) => {
  const { response, data } = resp;
  if (!err && !!data) {
    let tipo = "success";
    if (
      !!data.data &&
      typeof data.data === "object" &&
      data.data.length === 0
    ) {
      tipo = "info";
    }
    const mensaje = !!data.message ? data.message : "Consulta correcta";
    return configAlerta({ msg: mensaje, status: true, type: tipo });
  }

  if (!!response) {
    const { data, request } = response;
    if (!!data) {
      const tipo = !!data.message ? "warning" : "error";
      const { responseURL } = request;
      const msg = !!data.message ? data.message : "Error en la consulta";
      const err = !!data.error ? data.error : response.data;
      return configAlerta({
        msg,
        status: false,
        type: tipo,
        error: err,
        endpoint: responseURL,
      });
    }
  }
  return configAlerta({ msg: resp, status: false, type: "error", error: resp });
};

const state = {
  model: false,
  color: "info",
  position: {
    x: "right",
    y: "top",
  },
  msg: "",
  objecto: null,
  iconoTipo: {
    error: "mdi-close",
    warning: "mdi-alert",
    success: "mdi-check",
    info: "mdi-information",
  },
  errores: [],
};

const mutations = {
  setColor(state, color) {
    state.color = color;
  },
  setModel(state, model) {
    state.model = model;
  },
  setPosition(state, position) {
    state.position = position;
  },
  setMsg(state, msg) {
    state.msg = msg;
  },
  setObjeto(state, obj) {
    state.objecto = obj;
  },
  setErrores(state, errores) {
    state.errores = errores;
  },
};

const actions = {
  mostrarMensaje({ commit }, { color, position, msg }) {
    commit("setColor", color);
    commit("setModel", true);
    commit("setPosition", position);
    commit("setMsg", msg);
  },
  mostrarAlerta({ commit }, { message, position, color, error, endpoint }) {
    commit("setObjeto", {
      message,
      top: position.y == "top",
      bottom: position.y == "bottom",
      left: position.x == "left",
      right: position.x == "right",
      color,
      transition: "fade-transition",
      timeout: 4000,
    });
    if (color === "error" || color === "warning") {
      state.errores.push({
        title: message,
        message: error,
        color,
        endpoint,
      });
    }
  },
  limpiarErrores({ commit }) {
    commit("setErrores", []);
  },
};

const getters = {
  model: (state) => state.model,
  color: (state) => state.color,
  position: (state) => state.position,
  msg: (state) => state.msg,
  iconoTipo: (state) => state.iconoTipo,

  errores: (state) => state.errores,

  objecto: (state) => state.objecto,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
